let html = `<div class="card-more selector">
    <div class="card-more__box">
        <div class="card-more__title">
            #{more}
        </div>
    </div>
</div>`

export default html
